import React, { useState, useEffect } from "react";
import { PDFDocument, rgb } from "pdf-lib";

const PDF_CONFIG = {
    pageFromEnd: 2,
    signatureX: 85,
    signatureY: 102,
    signatureWidth: 120,
    signatureHeight: 30,
    businessNameX: 54,
    businessNameY: 123,
    nameX: 95,
    nameY: 91,
    licenseX: 180,
    licenseY: 76,
    dateX: 85,
    dateY: 61,
    fontSize: 10,
};

const PdfTest = () => {
    const [pdfUrl, setPdfUrl] = useState(null);
    const [config, setConfig] = useState(PDF_CONFIG);
    const [loading, setLoading] = useState(false);

    const sampleData = {
        name: "Amir S kazemi",
        businessName: "Apex Physical Therapy & Fitness",
        specialty: "Physical Therapy",
        state: "Texas",
        date: "5/14/2026",
    };

    const generatePdf = async () => {
        setLoading(true);
        try {
            const pdfUrl = "/agreements/Stamp_Medical_Clinical_Contractor_Agreement.pdf";
            const existingPdfBytes = await fetch(pdfUrl).then((r) => r.arrayBuffer());
            const pdfDoc = await PDFDocument.load(existingPdfBytes);

            const pages = pdfDoc.getPages();
            const pageIndex = pages.length - config.pageFromEnd;
            const targetPage = pages[pageIndex];

            // Draw business name
            targetPage.drawText(sampleData.businessName, {
                x: config.businessNameX,
                y: config.businessNameY,
                size: config.fontSize,
                color: rgb(0.8, 0, 0),
            });

            // Draw name
            targetPage.drawText(sampleData.name, {
                x: config.nameX,
                y: config.nameY,
                size: config.fontSize,
                color: rgb(0, 0, 0),
            });

            // Draw "[SIGNATURE]" placeholder
            targetPage.drawText("[SIGNATURE IMAGE]", {
                x: config.signatureX,
                y: config.signatureY + 5,
                size: 8,
                color: rgb(0, 0, 0.8),
            });

            // Draw license
            const licenseText = `${sampleData.specialty} / ${sampleData.state}`;
            targetPage.drawText(licenseText, {
                x: config.licenseX,
                y: config.licenseY,
                size: config.fontSize,
                color: rgb(0, 0, 0),
            });

            // Draw date
            targetPage.drawText(sampleData.date, {
                x: config.dateX,
                y: config.dateY,
                size: config.fontSize,
                color: rgb(0, 0, 0),
            });

            const pdfBytes = await pdfDoc.save();
            const blob = new Blob([pdfBytes], { type: "application/pdf" });
            const url = URL.createObjectURL(blob);
            setPdfUrl(url);
        } catch (err) {
            console.error("Error generating PDF:", err);
            alert("Error: " + err.message);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        generatePdf();
    }, []);

    const updateField = (field, value) => {
        setConfig((prev) => ({ ...prev, [field]: Number(value) }));
    };

    const fields = [
        { label: "Business Name X", key: "businessNameX" },
        { label: "Business Name Y", key: "businessNameY" },
        { label: "Signature X", key: "signatureX" },
        { label: "Signature Y", key: "signatureY" },
        { label: "Name X", key: "nameX" },
        { label: "Name Y", key: "nameY" },
        { label: "License X", key: "licenseX" },
        { label: "License Y", key: "licenseY" },
        { label: "Date X", key: "dateX" },
        { label: "Date Y", key: "dateY" },
        { label: "Font Size", key: "fontSize" },
    ];

    return (
        <div style={{ display: "flex", height: "100vh", fontFamily: "Arial, sans-serif" }}>
            <div style={{ width: 300, padding: 20, background: "#f5f5f5", overflowY: "auto", flexShrink: 0 }}>
                <h2 style={{ margin: "0 0 10px", fontSize: "1.1rem" }}>PDF Position Tester</h2>
                <p style={{ fontSize: "0.8rem", color: "#666", margin: "0 0 15px" }}>
                    Adjust values and click Regenerate. Business name is in <span style={{ color: "red", fontWeight: 700 }}>red</span>, signature placeholder in <span style={{ color: "blue", fontWeight: 700 }}>blue</span>.
                </p>
                {fields.map((f) => (
                    <div
                        key={f.key}
                        style={{ marginBottom: 8 }}>
                        <label style={{ fontSize: "0.8rem", fontWeight: 600, display: "block", marginBottom: 2 }}>{f.label}</label>
                        <input
                            type="number"
                            value={config[f.key]}
                            onChange={(e) => updateField(f.key, e.target.value)}
                            style={{ width: "100%", padding: "6px 8px", border: "1px solid #ccc", borderRadius: 4, boxSizing: "border-box" }}
                        />
                    </div>
                ))}
                <button
                    onClick={generatePdf}
                    disabled={loading}
                    style={{
                        width: "100%",
                        marginTop: 12,
                        padding: "10px",
                        background: loading ? "#999" : "#667eea",
                        color: "white",
                        border: "none",
                        borderRadius: 6,
                        cursor: loading ? "wait" : "pointer",
                        fontWeight: 700,
                        fontSize: "0.9rem",
                    }}>
                    {loading ? "Generating..." : "Regenerate PDF"}
                </button>
            </div>
            <div style={{ flex: 1 }}>
                {pdfUrl ? (
                    <iframe
                        src={pdfUrl}
                        style={{ width: "100%", height: "100%", border: "none" }}
                        title="PDF Preview"
                    />
                ) : (
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100%", color: "#999" }}>Generating PDF...</div>
                )}
            </div>
        </div>
    );
};

export default PdfTest;
